import { Component, computed, input, output, Inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { WindowToken } from '@app/shared/window.token';

export interface BreadcrumbItem {
  label: string;
  link?: string;
}

@Component({
  selector: 'da-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  standalone: true,
  imports: [NgClass, RouterLink, TranslateModule],
})
export class BreadcrumbComponent {
  public items = input.required<BreadcrumbItem[]>();
  public itemClick = output<BreadcrumbItem>();

  public i18n: Record<string, string> = this.translateService.instant([
    'Core_Breadcrumb',
  ]);

  public currentUrl = computed(
    () =>
      this.windowRef.location.pathname +
      this.windowRef.location.search +
      this.windowRef.location.hash
  );

  constructor(
    private translateService: TranslateService,
    @Inject(WindowToken) private windowRef: Window
  ) {}

  public onItemClick(item: BreadcrumbItem): void {
    this.itemClick.emit(item);
  }
}
